import React, {use, useState} from 'react';
import Header from '../componentes/Header';
import { NavLink, Link, useNavigate } from 'react-router';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import AnimacionPagina from '../componentes/AnimacionPagina';
import productosPersianas from '../data/todosLosProductos/productosPersianas';
import BtnVolverAnim from '../elementos/BtnVolverAnim';
import ModalImagenExpandida from '../componentes/ModalImagenExpandida';

import SectionProductos from '../elementos/SectionProductos';
import ContainerProductos from '../elementos/ContaninerProductos';
import ProductoContainer from '../elementos/ProductoContainer';
import { Helmet } from 'react-helmet';
import Footer from '../componentes/Footer';
import ToldosWhatsAppContact from '../componentes/ToldosWhastsAppContact';

const PaginaPersianas = () => {
    const navigate = useNavigate();
    const [imagenExpandida, setImagenExpandida] = useState(null);

    const [categoriaActiva, setCategoriaActiva] = useState('Sheer Elegance');
    const categorias = ['Sheer Elegance', 'Enrollables', 'Panel Japones'];
    return ( 
        <>
        <Helmet>
          <title>Persianas | Hi Blinds</title>
          <meta name="description" content="Persianas Sheer Elegance, enrollables, panel japonés y más. Estilo y control de luz garantizados." />
          <meta property="og:title" content="Persianas | Hi Blinds" />
          <meta property="og:description" content="Descubre nuestra variedad de persianas con diseño moderno y materiales premium. Con o sin motorización." />
          <meta property="og:url" content="https://hiblindsmx.com/persianas" />
        </Helmet>
        <Header />
        <AnimacionPagina>
            <SectionProductos>
                <h1>Persianas</h1>
                <BtnVolverAnim Ref="/" />
                <ContenedorPersianas>
                  {categorias.map((categoria) => (
                    <motion.div
                        whileHover={{ scale: 1.2 }}
                        whileTap={{ scale: 0.8 }}
                    >
                        <BotonCategoria
                          key={categoria}
                          activo={categoriaActiva === categoria}
                          onClick={() => setCategoriaActiva(categoria)}
                        >
                          {categoria}
                        </BotonCategoria>
                    </motion.div>
                    
                  ))}
                </ContenedorPersianas>
                <ContainerProductos>
                    {productosPersianas
                    .filter(p => p.categoria === categoriaActiva)
                    .map((producto, index) =>  {
                     return (
                        <motion.div
                        key={producto.id}
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4, delay: index * 0.1 }}
                        >
                            <ProductoContainer key={producto.id}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.8 }}
                             onClick={() => {
                              navigate(`/persianas/${producto.categoriaSlug}/${producto.slug}`);
                              }}
                              style={{ cursor: 'pointer' }}
                            >
                             <motion.img
                                loading='lazy' 
                                src={
                                  producto.categoria == 'Panel Japones' ? producto.images[1] : 
                                  producto.images[0]} 
                                alt={`${producto.nombre}`}
                                whileHover={{ scale: 1.02 }}
                                whileTap={{ scale: 0.7 }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setImagenExpandida(producto.images[0]);
                                }}
                              />
                             <h4>{producto.nombre}</h4>
                             <p>Ancho de tela de:
                              <br/>{producto.anchoTela}
                             </p>
                             <Link to={`/persianas/${producto.categoriaSlug}/${producto.slug}`}>
                                <button type='button'>Más información</button>
                             </Link>
                            </ProductoContainer>
                            
                        </motion.div>
                         
                     );
                    })}
                </ContainerProductos>
                 <ToldosWhatsAppContact 
                  phoneNumber="524773059542" 
                  defaultMessage="Quiero saber sobre los insumos para armar persinas, toldos y cortineros" 
                  />
                <BtnVolverAnim Ref="/" />
            </SectionProductos>
            <Footer />
        </AnimacionPagina>
        <ModalImagenExpandida
                imagen={imagenExpandida}
                onClose={() => setImagenExpandida(null)}
              />
        </>
     );
}

const ContenedorPersianas = styled.div `
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    padding: 15px 10px;
    justify-content: center;
    margin-top: 10px;
`
const BotonCategoria = styled.button`
  background-color: ${({ activo }) => (activo ? ' #959cfa' : '#010755')};
  color: #fff;
  padding: 12px 12px;
  min-width: 165px;
  max-width: 165px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: transform .3s, background .5s;

`;
export default PaginaPersianas;